import tree from "../../../components/tree.vue";
import iTable from "../../../components/Table.vue";
import IPagination from "../../../components/pagination.vue";
import {
    domainName
} from "../../../utility/index"
import {
    downLoadTemplateFile,
    downLoadFile,
    exportCarData
} from '../../../api/config/modules/DriverFile'

export default {
    name: "DriverFile",
    components: {
        tree,
        iTable,
        IPagination
    },
    data() {
        return {
            isCollapse: false,
            stateArrow: true,
            isSearch: true,
            formInline: {
                driverNum: '',
                name: '',
                loginName: ''
            },
            height: '550',
            list: [],
            option: {
                stripe: true,
                border: true,
                loading: false,
                highlightCurrentRow: false,
                mutiSelect: true,
                serialNumber: true,
            },
            columns: [{
                prop: "driverNum",
                label: this.$t('DriverManagement.driverNum'),
                align: "center",
                width: "160px"
            },
            {
                prop: "name",
                label: this.$t('DriverManagement.name'),
                align: "center",
                width: "120px"
            },
            {
                prop: "orgName",
                label: this.$t('common.orgName'),
                align: "center",
                width: "120px"
            },
            {
                prop: "loginName",
                label: this.$t('DriverManagement.loginName'),
                align: "center",
                width: "120px"
            },
            {
                prop: "phone",
                label: this.$t('DriverManagement.phone'),
                align: "center",
                width: "140px"
            },
            {
                prop: "card",
                label: this.$t('DriverManagement.card'),
                align: "center",
                width: "180px"
            },
            {
                prop: "resignationStateStr",
                label: '在职状态',
                align: "center",
                width: "180px"
            },
            {
                prop: "resignationTime",
                label: '离职时间',
                align: "center",
                width: "180px"
            },
            {
                prop: "driverTypeStr",
                label: '司机类型',
                align: "center",
                width: "180px"
            },
            {
                prop: "staffNum",
                label: '职员证号',
                align: "center",
                width: "180px"
            },
            {
                prop: "dsmStateStr",
                label: '推送状态',
                align: "center",
                width: "160px"
            },
            {
                prop: "remarks",
                label: this.$t('DriverManagement.remarks'),
                align: "center",
            },
            ],
            operates: {
                width: 100,
                fixed: "right",
                list: [
                ],
            },
            currentPage: 1,
            pageSize: 10,
            total: 1,
            typeList: [],
            dialogFormVisible: false,
            formLabelWidth: '122px',
            diaTitle: '',
            btnType: '',
            isShow: false,
            rules: {
                driverNum: [{
                    required: true,
                    message: this.$t('DriverManagement.form.driverNumber'),
                    trigger: 'blur'
                }],
                name: [{
                    required: true,
                    message: this.$t('DriverManagement.form.driverName'),
                    trigger: 'blur'
                }],
            },
            form: {
                driverNum: '',
                phone: '',
                name: '',
                card: '',
                resignationState: '',
                resignationTime: '',
                driverType: '',
                staffNum: '',
                remarks: '',
                isRelevancy: 0,
                email: '',
                rolePower: '',
                roleData: ''
            },
            disabled: false,
            dialogTransferFormVisible: false,
            LabelWidth: '104px',
            TransferRules: {},
            TransferForm: {
                driverNum: '',
                roleId: ''
            },
            selected: [],
            id: '',
            name: '',
            dialogBatchFormVisible: false,
            ChangeCarForm: {
                driverNum: '',
                newDriverNum: '',
                loginName: ''
            },
            ChangeCarRules: {},
            dialogCarFormVisible: false,
            isDisplay: true,

            dialogPowerVisible: false,
            data: [],
            defaultProps: {
                children: 'children',
                label: 'value',
            },
            keyList: [],
            filterText: '',
            selected: [],
            rolePower: '',
            companyId: '',
            diaHidden: false,
            RoleList: [],
        }
    },
    watch: {
        filterText(val) {
            this.$refs.tree.filter(val);
        }
    },
    created() {
        this.getRole()
    },
    methods: {
        toggleSideBar() {
            this.isCollapse = !this.isCollapse
            this.$store.dispatch('menuTab/toggleSideBar', this.isCollapse)
        },
        changeArrow() {
            this.stateArrow = !this.stateArrow
        },
        initQuery(item) {
            this.id = item.id
            this.name = item.name
            if (this.$route.params.driverExpirationId) {
                this.formInline.state = this.$route.params.driverExpirationId
            }
            this.getAllDriver()
        },
        nodeClick(val) {
            this.id = val.label
            this.name = val.value
            this.getAllDriver()
        },
        getAllDriver() {
            let param = {
                orgId: this.id,
                driverNum: this.formInline.driverNum,
                name: this.formInline.name,
                loginName: this.formInline.loginName,
                pageNum: this.currentPage,
                pageSize: this.pageSize,
            }
            this.$store.dispatch('DriverFile/GET_SELECTALLDRIVER', param).then(res => {
                if (res) {
                    console.log(res)
                    if (res.data.code == 200) {
                        this.list = res.data.data.list
                        this.$refs.page.CommandTotal = res.data.data.total
                    }
                }
            }).catch(err => { })
        },
        onSearch() {
            this.$refs.page.CommandCurrentPage = 1
            this.currentPage = 1
            this.getAllDriver()
        },
        onClear() {
            this.formInline = {
                driverNum: '',
                name: '',
                loginName: ''
            }
            this.getAllDriver()
        },
        addDriver() {
            this.dialogFormVisible = true
            this.diaTitle = this.$t('common.btn.add')
            this.btnType = 'add'
            this.disabled = false
            this.isShow = true
            this.$nextTick(() => {
                this.$refs.form.resetFields()
                this.form.driverNum = ''
                this.form.phone = ''
                this.form.name = ''
                this.form.card = ''
                this.form.resignationState = ''
                this.form.resignationTime = ''
                this.form.driverType = ''
                this.form.staffNum = ''
                this.form.remarks = ''
                this.form.isRelevancy = ''
                this.form.email = ''
                this.form.rolePower = ''
                this.form.roleData = ''
            })

        },
        editDriver() {
            this.dialogFormVisible = true
            this.diaTitle = this.$t('common.btn.edit')
            this.btnType = 'edit'
            this.disabled = true
            this.$nextTick(() => {
                this.$refs.form.clearValidate()
            })
            this.isShow = false
            this.form.driverNum = this.selected[0].driverNum
            this.form.phone = this.selected[0].phone
            this.form.name = this.selected[0].name
            this.form.card = this.selected[0].card
            this.form.resignationState = String(this.selected[0].resignationState)
            this.form.resignationTime = this.selected[0].resignationTime
            this.form.driverType = String(this.selected[0].driverType)
            this.form.staffNum = this.selected[0].staffNum
            this.form.remarks = this.selected[0].remarks
            this.form.isRelevancy = this.selected[0].isRelevancy
            this.form.email = this.selected[0].email
            this.form.rolePower = this.selected[0].rolePower
            this.form.roleData = this.selected[0].roleData
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    let param = {
                        companyId: sessionStorage.getItem("companyId"),
                        orgId: this.id,
                        driverNum: this.form.driverNum,
                        phone: this.form.phone,
                        name: this.form.name,
                        card: this.form.card,
                        resignationState: this.form.resignationState,
                        resignationTime: this.form.resignationTime,
                        driverType: this.form.driverType,
                        staffNum: this.form.staffNum,
                        remarks: this.form.remarks,
                        isRelevancy: Number(this.form.isRelevancy),
                        email: this.form.email,
                        rolePower: this.form.rolePower,
                        roleData: this.form.roleData
                    }
                    if (this.btnType == 'add') {
                        this.$store.dispatch('DriverFile/GET_INSERTDRIVER', param).then(res => {
                            if (res.data.code == 200) {
                                this.$message.success(this.$t('common.btn.addSuccess'))
                                this.dialogFormVisible = false;
                                this.getAllDriver();
                                this.closeDia();
                            } else {
                                this.$message.error(res.data.msg)
                            }

                        }).catch(err => { })
                    } else {
                        this.$store.dispatch('DriverFile/GET_UPDATEDRIVER', param).then(res => {
                            if (res.data.code == 200) {
                                this.$message.success(this.$t('common.btn.editSuccess'))
                                this.dialogFormVisible = false;
                                this.getAllDriver();
                                this.closeDia();
                            } else {
                                this.$message.error(res.data.msg)
                            }

                        }).catch(err => { })
                    }


                } else {
                    return false;
                }
            });
        },
        cancle(formName) {
            this.dialogFormVisible = false;
            this.form = {
                driverNum: '',
                phone: '',
                name: '',
                card: '',
                resignationState: '',
                resignationTime: '',
                driverType: '',
                staffNum: '',
                remarks: '',
                isRelevancy: 0,
                email: '',
                rolePower: '',
                roleData: ''
            }
        },
        closeDia() {
            this.form = {
                driverNum: '',
                phone: '',
                name: '',
                card: '',
                resignationState: '',
                resignationTime: '',
                driverType: '',
                staffNum: '',
                remarks: '',
                isRelevancy: 0,
                email: '',
                rolePower: '',
                roleData: ''
            }
            this.dialogFormVisible = false;
        },

        getRole() {
            this.$store.dispatch('roleManagement/GET_QUERY', {}).then(res => {
                if (res) {
                    if (res.data.code == 200) {
                        this.RoleList = res.data.data
                    }
                }
            })
        },
        filterNode(value, data) {
            if (!value) return true;
            return data.value.indexOf(value) !== -1;
        },
        getTree() {
            let param = {
                orgId: sessionStorage.getItem("roleData"),
                companyId: sessionStorage.getItem("companyId"),
            }
            this.$store.dispatch('tree/GET_QUERYTREE', param).then(res => {
                if (res) {
                    if (res.data.code == 200) {
                        this.data = res.data.data
                    }
                }
            })
        },
        getPower() {
            this.dialogPowerVisible = true
            this.diaHidden = true
            this.getTree()
            this.$nextTick(() => {
                this.$refs.tree.setCheckedKeys(this.keyList)
            })
        },
        submit(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.form.roleData = this.$refs.tree.getCheckedKeys().join(',')
                    this.dialogPowerVisible = false
                    this.diaHidden = true
                } else {
                    return false;
                }
            });
        },
        handleClose() {
            this.dialogPowerVisible = false
            this.diaHidden = false
        },

        deleteDriver() {
            this.$confirm(this.$t('common.btn.confirmDelete'), this.$t('common.btn.hint'), {
                cancelButtonText: this.$t('common.btn.cancel'),
                confirmButtonText: this.$t('common.btn.confirm'),
                type: 'warning'
            }).then(res => {
                let param = {
                    driverNums: this.selected.map(item => item.driverNum).join()
                }
                this.$store.dispatch('DriverFile/GET_DELETEDRIVER', param).then(response => {
                    if (response.data.code == 200) {
                        this.getAllDriver()
                        this.$message.success(this.$t('common.btn.deleteSuccess'))
                    } else {
                        this.$message.error(response.data.msg)
                    }
                }).catch(error => { })
            }).catch(err => {

            })
        },
        transferDriver() {
            this.dialogTransferFormVisible = true
            this.TransferForm.driverNum = ''
            this.selected.map(item => {
                if (this.selected.length > 1) {
                    this.TransferForm.driverNum = this.TransferForm.driverNum.concat((item.driverNum + '-' + item.orgName + ','))
                } else {
                    this.TransferForm.driverNum = this.TransferForm.driverNum.concat((item.driverNum + '-' + item.orgName))
                }
            })
        },
        changeClick(val) {
            this.roleId = val.label
        },
        submitTransferForm(TransferFormName) {
            this.$refs[TransferFormName].validate((valid) => {
                if (valid) {
                    let driverNums = ''
                    this.selected.map((item, index) => {
                        if (index == 0) {
                            driverNums = item.driverNum
                        } else {
                            driverNums = driverNums + ',' + item.driverNum
                        }
                    })
                    let param = {
                        driverNums: driverNums,
                        orgId: this.roleId
                    }
                    this.$store.dispatch('DriverFile/GET_BATCHDRIVER', param).then(res => {
                        if (res.data.code == 200) {
                            this.$message.success(this.$t('common.btn.transferSuccess'))
                            this.dialogTransferFormVisible = false;
                            this.getAllDriver();
                            this.closeTransfer();
                        } else {
                            this.$message.error(res.data.msg)
                        }

                    }).catch(err => { })
                } else {
                    return false;
                }
            });
        },
        cancleTransfer(TransferFormName) {
            this.dialogTransferFormVisible = false;
            this.TransferForm = {
                driverNum: '',
                roleId: ''
            }
        },
        closeTransferDia() {
            this.TransferForm = {
                driverNum: '',
                roleId: ''
            }
            this.dialogTransferFormVisible = false;
        },
        push() {
            let param = {
                driverNum: this.selected[0].driverNum,
            }
            this.$store.dispatch('DriverFile/GET_DRIVERPUSH', param).then(res => {
                if (res.data.code == 200) {
                    this.$message.success(this.$t('TopBar.form.pushSuccess'))
                    this.getAllDriver()
                } else {
                    this.$message.error(res.data.msg)
                }
            }).catch(err => { })
        },

        BulkImport() {
            this.dialogBatchFormVisible = true
        },

        TemplateFile() {
            if (domainName) {
                if (domainName.split(':')[0] !== 'localhost') {
                    let url = `https://${domainName}/v1/getExportExcel/exportDriverModel`
                    location.href = url

                } else {
                    let host = 'localhost:8080'
                    let url = `https://${host}/v1/getExportExcel/exportDriverModel`
                    location.href = url

                }
            }
        },

        uploadFile(e) {
            let dom = document.getElementById('uploadDom')
            let file = dom.files[0];
            let companyId = sessionStorage.getItem('companyId')
            let userId = sessionStorage.getItem('userId')
            let orgId = this.id
            let formData = new FormData()
            formData.append('File', file)
            formData.append('userId', userId)
            formData.append('companyId', companyId)
            formData.append('orgId', orgId)
            let types = file.name.split('.')[1]
            if (types != "xlsx" && types != "xls") {
                this.$message.error(this.$t('common.btn.choseExcelFile'));
                return false;
            } else {
                this.$store.dispatch('DriverFile/GET_UPLOADDRIVER', formData).then(res => {
                    if (res.data.code == 200) {
                        this.$message.success(this.$t('common.btn.fileUploadSuccess'))
                        this.dialogBatchFormVisible = false;
                        this.getAllDriver()
                    } else {
                        this.$message.error(res.data.msg)
                    }
                    document.getElementById('uploadDom').value = ''
                }).catch(err => {
                    this.$message.error(this.$t('common.btn.fileUploadError'))
                    document.getElementById('uploadDom').value = ''
                })
            }
        },
        closeBatchDia() {
            this.dialogBatchFormVisible = false
        },
        downDriver() {
            if (domainName) {
                if (domainName.split(':')[0] !== 'localhost') {
                    let url = `https://${domainName}/v1/getExportExcel/exportDriver?orgId=${this.id}&driverNum=${this.formInline.driverNum}&name=${this.formInline.name}&loginName=${this.formInline.loginName}`
                    location.href = url


                } else {
                    let host = 'localhost:8080'
                    let url = `https://${host}/v1/getExportExcel/exportDriver?orgId=${this.id}&driverNum=${this.formInline.driverNum}&name=${this.formInline.name}&loginName=${this.formInline.loginName}`
                    location.href = url

                }
            }
        },

        changeDriverNum() {
            this.dialogCarFormVisible = true
            this.isShow = true
            this.$nextTick(() => {
                this.ChangeCarForm.driverNum = this.selected[0].driverNum
            })
        },
        bindName() {
            this.dialogCarFormVisible = true
            this.isShow = false
            this.$nextTick(() => {
                this.ChangeCarForm.driverNum = this.selected[0].driverNum
                this.ChangeCarForm.loginName = this.selected[0].loginName
                if (this.ChangeCarForm.loginName) {
                    this.isDisplay = true
                } else {
                    this.isDisplay = false
                }
            })
        },
        closeCarDia() {
            this.dialogCarFormVisible = false
            this.ChangeCarForm = {
                driverNum: '',
                newDriverNum: '',
                loginName: ''
            }
        },
        cancleCarChange(ChangeCarFormName) {
            this.dialogCarFormVisible = false
            this.ChangeCarForm = {
                driverNum: '',
                newDriverNum: '',
                loginName: ''
            }
        },
        submitCarForm(ChangeCarFormName) {
            this.$refs[ChangeCarFormName].validate((valid) => {
                if (valid) {
                    if (this.isShow == true) {
                        let param = {
                            driverNum: this.ChangeCarForm.driverNum,
                            newDriverNum: this.ChangeCarForm.newDriverNum
                        }
                        this.$store.dispatch('DriverFile/GET_UPDATEDRIVERNUM', param).then(res => {
                            if (res.data.code == 200) {
                                this.$message.success(this.$t('common.btn.editSuccess'))
                                this.dialogCarFormVisible = false;
                                this.getAllDriver();
                                this.closeCarDia();
                            } else {
                                this.$message.error(res.data.msg)
                            }

                        }).catch(err => { })
                    } else {
                        let param = {
                            driverNum: this.ChangeCarForm.driverNum,
                            loginName: this.ChangeCarForm.loginName,
                            updateType: 1
                        }
                        this.$store.dispatch('DriverFile/GET_UPDATEDRIVERUSER', param).then(res => {
                            if (res.data.code == 200) {
                                this.$message.success(this.$t('common.btn.bindSuccess'))
                                this.dialogCarFormVisible = false;
                                this.getAllDriver();
                                this.closeCarDia();
                            } else {
                                this.$message.error(res.data.msg)
                            }

                        }).catch(err => { })
                    }

                } else {
                    return false;
                }
            });
        },
        Relieve() {
            this.$confirm(this.$t('common.btn.bindText'), this.$t('common.btn.hint'), {
                cancelButtonText: this.$t('common.btn.cancel'),
                confirmButtonText: this.$t('common.btn.confirm'),
                type: 'warning'
            }).then(res => {
                let param = {
                    updateType: 0,
                    loginName: '',
                    driverNum: this.selected[0].driverNum
                };
                this.$store.dispatch('DriverFile/GET_UPDATEDRIVERUSER', param).then(response => {
                    if (response.data.code == 200) {
                        this.dialogCarFormVisible = false;
                        this.getAllDriver();
                        this.$message.success(this.$t('common.btn.unBindSuccess'))
                    } else {
                        this.$message.error(response.data.msg)
                    }
                }).catch(error => { })
            }).catch(err => {

            })
        },

        handleSelectionChange(val) {
            console.log(val)
            this.selected = val
        },
        changeSize(item) {
            this.pageSize = item.pageSize
            this.currentPage = item.pageNum
            this.getAllDriver();
        },
        onResize: function (x, y, width, height) {
            let box = document.getElementById("leftBox");
            box.style.width = width + "px";
        },
    }
}